export default "__VITE_ASSET__4bf19d9b__"